// ─── Design tokens ───────────────────────────────────────────────────────────
export const T = {
  // Glass surfaces — calibrated to read on vibrant ambient backgrounds
  glass:       'rgba(255,255,255,0.62)',
  glassHover:  'rgba(255,255,255,0.78)',
  glassBorder: 'rgba(255,255,255,0.55)',
  glassDark:   'rgba(255,255,255,0.42)',
  glassElevated: 'rgba(255,255,255,0.74)',
  glassSunken: 'rgba(255,255,255,0.36)',

  // Shadows — softer, larger, more ambient
  shadow:      '0 12px 40px rgba(60,40,90,0.10), 0 2px 8px rgba(60,40,90,0.05)',
  shadowLg:    '0 28px 80px rgba(60,40,90,0.14), 0 6px 20px rgba(60,40,90,0.08)',
  shadowSm:    '0 2px 10px rgba(60,40,90,0.06)',

  // Typography
  text:        '#1a1a1a',
  textMid:     '#4a4a4a',
  textMuted:   '#8a8a8a',
  textLight:   '#b0b0b0',

  // Background — vibrant Apple-style ambient gradients (base layer; light orbs are layered separately)
  bg:          'linear-gradient(135deg, #e8d8f5 0%, #d8c8ee 25%, #e0d4ee 50%, #e8d8e8 75%, #f0d8e0 100%)',
  bgMorning:   'linear-gradient(135deg, #f8e8d0 0%, #f0d8c8 25%, #ecd5d8 50%, #ebd2dc 75%, #e8d0e0 100%)',
  // Late twilight — deeper saturated violet/dusk-rose, "lights coming on" feel.
  // Kept legible with dark text; for proper night mode see bgEvening overrides at OS-dark.
  bgEvening:   'linear-gradient(135deg, #b8a0d8 0%, #a89cc8 25%, #b8a4d0 50%, #c8a8c2 75%, #d4a8b8 100%)',

  // Role colors
  amber:       '#D4921E',
  amberLight:  'rgba(212,146,30,0.12)',
  amberBorder: 'rgba(212,146,30,0.25)',
  blue:        '#4A9ECC',
  blueLight:   'rgba(74,158,204,0.12)',
  violet:      '#8B72C8',
  violetLight: 'rgba(139,114,200,0.12)',
  green:       '#5A9E78',
  greenLight:  'rgba(90,158,120,0.12)',
  rose:        '#C86878',
  roseLight:   'rgba(200,104,120,0.12)',
  red:         '#e05858',
  redLight:    'rgba(224,88,88,0.10)',
};

export const ROLES = {
  liken:    { label: 'Liken',    color: T.amber,  light: T.amberLight,  border: T.amberBorder  },
  oneday:   { label: 'Oneday',   color: T.blue,   light: T.blueLight,   border: 'rgba(74,158,204,0.25)'  },
  pryke:    { label: 'Pryke',    color: T.violet, light: T.violetLight, border: 'rgba(139,114,200,0.25)' },
  personal: { label: 'Personal', color: T.green,  light: T.greenLight,  border: 'rgba(90,158,120,0.25)'  },
};

export const HEALTH = {
  'on-track': { label: 'On Track', color: T.green, bg: 'rgba(90,158,120,0.10)', border: 'rgba(90,158,120,0.20)' },
  'drifting': { label: 'Drifting', color: T.amber, bg: 'rgba(212,146,30,0.10)', border: 'rgba(212,146,30,0.20)' },
  'at-risk':  { label: 'At Risk',  color: T.red,   bg: 'rgba(224,88,88,0.10)',   border: 'rgba(224,88,88,0.20)' },
  'overdue':  { label: 'Overdue',  color: T.red,   bg: 'rgba(224,88,88,0.10)',   border: 'rgba(224,88,88,0.20)' },
  'done':     { label: 'Done',     color: T.green, bg: 'rgba(90,158,120,0.10)',  border: 'rgba(90,158,120,0.20)' },
};

export const GOAL_PRIORITY = {
  1: { label: 'Critical', color: T.red,      bg: T.redLight,    border: 'rgba(224,88,88,0.20)' },
  2: { label: 'High',     color: T.amber,    bg: T.amberLight,  border: T.amberBorder },
  3: { label: 'Medium',   color: T.blue,     bg: T.blueLight,   border: 'rgba(74,158,204,0.25)' },
  4: { label: 'Low',      color: T.textMuted, bg: 'rgba(0,0,0,0.04)', border: 'rgba(0,0,0,0.08)' },
};

// Spring animation configs for framer-motion
export const springs = {
  snappy:  { type: 'spring', stiffness: 400, damping: 30 },
  gentle:  { type: 'spring', stiffness: 200, damping: 25 },
  bouncy:  { type: 'spring', stiffness: 500, damping: 15 },
};

// Blur depths for glass layers
export const blurs = {
  sm: 'blur(12px) saturate(180%)',
  md: 'blur(20px) saturate(180%)',
  lg: 'blur(32px) saturate(200%)',
  xl: 'blur(48px) saturate(200%)',
};
